import styled from "styled-components";

export const ErrorLabelStyle = styled.div`
  color: #EA5455;
  font-size: 12px;
`